// Contexto de Tema para la aplicación Amarsi Control Panel
// Maneja el estado global del tema (claro/oscuro) y persistencia

import React, { createContext, useContext, useState, useEffect } from 'react';

// Creación del contexto
const ThemeContext = createContext();

// Hook personalizado para usar el contexto de tema
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe ser usado dentro de un ThemeProvider');
  }
  return context;
};

// Provider del contexto de tema
export const ThemeProvider = ({ children }) => {
  // Estado local para el tema
  const [isDark, setIsDark] = useState(() => {
    // Recupera el tema guardado en localStorage o usa preferencia del sistema
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    // Usa preferencia del sistema si no hay tema guardado
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Efecto para aplicar la clase al documento y guardar en localStorage
  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  // Función para toggle del tema
  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  // Objeto de valor del contexto
  const value = {
    isDark,
    toggleTheme,
    theme: isDark ? 'dark' : 'light'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
